import React, { useEffect } from 'react'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import { styled } from '@mui/system'
import { useState } from 'react'
import FranchiseeToOwn from './franchiseeToOwn/FranchiseeToOwn'
import FranchiseeBookings from './franchiseeBookings/FranchiseeBookings'
import OwnBookings from './ownBooking/OwnBookings'
import { connect } from 'react-redux'
import { isEmpty } from '../../../common/helper'
import { updateOwnBooingFitlerData } from '../../../../store/reports/reports_action'
import OwnBookingsNew from './ownBooking/OwnBookingsNew'
import FranchiseeBookingsNew from './franchiseeBookings/FranchiseeBookingsNew'
import FranchiseeToOwnNew from './franchiseeToOwn/FranchiseeToOwnNew'
const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))
const Index = (props) => {
  const {
    data: { common },
    updateOwnBooingFitlerData,
  } = props
  const { loginData, roleRights } = common
  const [selectedTab, setSelectedTab] = useState(0)
  const [disableBtn, setDisableBtn] = useState(false)

  const reportName = 'Booking'
  const tabLabels = ['Own Bookings', 'Franchisee Bookings', 'Franchisee to own']
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
    updateOwnBooingFitlerData([])
  }
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
    }
  }, [roleRights, loginData])
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <Box className="reports">
        <ReportHeading reportName={reportName} />
      </Box>
      <Box>
        <StyledTabs
          aria-label="basic tabs example"
          value={selectedTab}
          onChange={handleTabChange}
          sx={{ backgroundColor: '#e5f3fe', height: '30px', minHeight: '37px', border: 'none', padding: '0px 25px' }}
        >
          {' '}
          <Tab
            sx={{
              minHeight: '30px',
              height: '30px',
              '&.Mui-selected': {
                border: 'none',
                minHeight: '30px',
                height: '30px',
              },
            }}
            label={tabLabels[0]}
          />{' '}
          <Tab
            disabled={disableBtn}
            sx={{
              minHeight: '30px',
              height: '30px',
              '&.Mui-selected': {
                border: 'none',
                minHeight: '30px',
                height: '30px',
              },
            }}
            label={tabLabels[1]}
          />{' '}
          <Tab
            sx={{
              minHeight: '30px',
              height: '30px',
              '&.Mui-selected': {
                border: 'none',
                minHeight: '30px',
                height: '30px',
              },
            }}
            label={tabLabels[2]}
          />{' '}
        </StyledTabs>
      </Box>
      <Box>
        {(selectedTab === 0 && <OwnBookingsNew />) ||
          (selectedTab === 1 && <FranchiseeBookingsNew />) ||
          (selectedTab === 2 && <FranchiseeToOwnNew />)}
      </Box>
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateOwnBooingFitlerData }
export default connect(mapStateToProps, mapDispatchToProps)(Index)
